import React from 'react';
import { IconProps } from '../types';
const MinecraftGlowBerries: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="8" y="1" width="1" height="1" fill="rgba(100, 146, 45, 255)" />
<rect x="9" y="1" width="1" height="1" fill="rgba(82, 123, 33, 255)" />
<rect x="10" y="1" width="1" height="1" fill="rgba(82, 123, 33, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(100, 146, 45, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(79, 50, 20, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(43, 84, 30, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(47, 101, 43, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(195, 198, 47, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(79, 50, 20, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(91, 64, 18, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(43, 84, 30, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(43, 84, 30, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(82, 123, 33, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(195, 198, 47, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(91, 64, 18, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(112, 82, 29, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(91, 64, 18, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(43, 84, 30, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(43, 84, 30, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(43, 84, 30, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(195, 198, 47, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(91, 64, 18, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(112, 82, 29, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(112, 82, 29, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(43, 84, 30, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(43, 84, 30, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(100, 146, 45, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(195, 198, 47, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(191, 103, 23, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(191, 103, 23, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(191, 103, 23, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(191, 103, 23, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(112, 82, 29, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(43, 84, 30, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(47, 101, 43, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(195, 198, 47, 255)" />
<rect x="2" y="7" width="1" height="1" fill="rgba(191, 103, 23, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(241, 150, 69, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(244, 192, 94, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(244, 192, 94, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(241, 150, 69, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(191, 103, 23, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(112, 82, 29, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(47, 101, 43, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(47, 101, 43, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(195, 198, 47, 255)" />
<rect x="1" y="8" width="1" height="1" fill="rgba(191, 103, 23, 255)" />
<rect x="2" y="8" width="1" height="1" fill="rgba(241, 150, 69, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(247, 226, 107, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(247, 226, 107, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(213, 114, 25, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(213, 114, 25, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(241, 150, 69, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(146, 68, 26, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(112, 82, 29, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(47, 101, 43, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(56, 114, 51, 255)" />
<rect x="13" y="8" width="1" height="1" fill="rgba(100, 146, 45, 255)" />
<rect x="1" y="9" width="1" height="1" fill="rgba(191, 103, 23, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(241, 150, 69, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(247, 226, 107, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(241, 150, 69, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(213, 114, 25, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(191, 103, 23, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(244, 192, 94, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(146, 68, 26, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(91, 64, 18, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(56, 114, 51, 255)" />
<rect x="13" y="9" width="1" height="1" fill="rgba(100, 146, 45, 255)" />
<rect x="1" y="10" width="1" height="1" fill="rgba(191, 103, 23, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(241, 150, 69, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(241, 150, 69, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(191, 103, 23, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(191, 103, 23, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(191, 103, 23, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(244, 192, 94, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(146, 68, 26, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(191, 103, 23, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(191, 103, 23, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(56, 114, 51, 255)" />
<rect x="1" y="11" width="1" height="1" fill="rgba(191, 103, 23, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(241, 150, 69, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(213, 114, 25, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(191, 103, 23, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(191, 103, 23, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(241, 150, 69, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(247, 226, 107, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(146, 68, 26, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(244, 192, 94, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(241, 150, 69, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(146, 68, 26, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(146, 68, 26, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(241, 150, 69, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(241, 150, 69, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(213, 114, 25, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(247, 226, 107, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(146, 68, 26, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(191, 103, 23, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(241, 150, 69, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(241, 150, 69, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(146, 68, 26, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(146, 68, 26, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(146, 68, 26, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(146, 68, 26, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(146, 68, 26, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(191, 103, 23, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(241, 150, 69, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(241, 150, 69, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(213, 114, 25, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(146, 68, 26, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(146, 68, 26, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(146, 68, 26, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(146, 68, 26, 255)" />
</svg>);
export default MinecraftGlowBerries;